import React from 'react';
import { motion } from 'framer-motion';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Introduction } from './components/Introduction';
import { ErrorSection } from './components/ErrorSection';
import { EditorialQuote } from './components/EditorialQuote';
import { FinalSection } from './components/FinalSection';
import { RelatedGuides } from './components/RelatedGuides';
import { Footer } from './components/Footer';
import { guideErrors } from './data/guide';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel({
    contentName: 'Fresh Guide #1 — Los 7 errores que hacen que una crema no funcione',
    contentType: 'guide'
  });
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.9,
    ease: [0.22, 1, 0.36, 1]
  }} className="min-h-full w-full bg-warmwhite font-sans antialiased" data-id="element-0" data-mp="2wiffjcn976y6">
      <Header data-id="element-1" data-mp="23v2sl1d6kx4c" />

      <main data-id="element-2" data-mp="23ti7s3go4sjo">
        <Hero data-id="element-3" data-mp="3ijxsgzk2wgo4" />
        <Introduction data-id="element-4" data-mp="3ikhaeg9qb525" />

        <section aria-label="Los siete errores" className="bg-warmwhite" data-id="element-5" data-mp="3ij64oawq3n8e">
          <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-6" data-mp="3ml1234bj9ggw">
            
          </div>
          <div className="mt-16" data-id="element-7" data-mp="3rcj846sey78q">
            {guideErrors.map((item, i) => <ErrorSection key={item.number} item={item} reversed={i % 2 === 1} data-id="element-8" data-mp="3recedkz46pg7" data-mpi={i} />)}
          </div>
        </section>

        <EditorialQuote data-id="element-9" data-mp="2zl39tfhhuw2o" />
        <FinalSection data-id="element-10" data-mp="2zlld2w2kqak3" />
        <RelatedGuides data-id="element-11" data-mp="2zmeowbge3q93" />
      </main>

      <Footer data-id="element-12" data-mp="2zng14j956ise" />
    </motion.div>;
}